const getLinkPreviewImageAspectRatio = (webpage) => {
  if (!webpage) return null;
  const { width, height } = webpage?.image ?? {};
  if (!width || !height) return null;
  return width / height;
};

export { getLinkPreviewImageAspectRatio as default };
//# sourceMappingURL=getLinkPreviewImageAspectRatio.js.map
